import { CategoryDisplayName } from '@oxappsec/ox-consolidated-categories';
import { generateCategoryIcon } from 'common-icons';
import { IconType, Nullable } from 'common-types';
import { splitLongNames } from 'string-utils';
import {
  Filter,
  FilterIssueType,
  SearchInput,
} from '../../issues/common/types/issues-types';
import { getCurrentTheme } from '../themes';

export enum FilterType {
  apps = 'Application',
  criticality = 'Severity',
  fixedIssues = 'Fixed Issues',
  category = 'Category',
  issueNames = 'Issue Name',
  policies = 'Policy',
  issueOwners = 'Issue Owner',
  appBusinessPriority = 'Business Priority',
  sourceTools = 'Source Tool',
  cwe = 'CWE',
  categories = 'Category',
  repoTypes = 'Source Control',
  orchestrators = 'Orchestrator',
  artifactsType = 'Artifact Type',
  artifactsSystem = 'Registry',
  cicd = 'CI/CD',
  cloudDeployments = 'Cloud Deployment',
  kubernetes = 'Container as a Service',
  sca = 'SCA Coverage',
  sast = 'SAST Coverage',
  secretSearch = 'Secret Coverage',
  iac = 'IAC Coverage',
  securityToolSource = 'Security Tool Source',
  severityChange = 'Severity Change',
  severityChangeReasons = 'Severity Factor',
  issueStatus = 'Issue Status',
  issuesActions = 'Actions',
  sourceControl = 'Source Control',
  cloudTechnology = 'Cloud Technology',
  enviorment = 'Enviorment',
  user = 'User',
  version = 'Version',
  executionStatus = 'Execution Status',
  registryType = 'Registry Type',
  jobTriggeredBy = 'Job Triggered By',
  enforcement = 'Result',
  cicdIssueStatus = 'Pipeline Issue Status',
  jobNumber = 'Job Number',
  pullRequests = 'Pull Request',
  libraryNames = 'Library Name',
  libraryVersions = 'Library Version',
  source = 'Source',
  dependencyTypes = 'Dependency',
  licenses = 'License',
  packageNames = 'Package Name',
  oxInPipeline = 'Ox In Pipeline',

  result = 'Result',
  targetBranches = 'Target Branch',
  sourceBranches = 'Scanned Branch',
  severity = 'Severities',
  eventType = 'Event Type',
  originalSeverity = 'Original Severity',
  languages = 'Languages',
  pkgManagers = 'Package Manager',
  appName = 'App Name',
  exclusionType = 'Type',
  modifiedBy = 'Created By',
  policyName = 'Policy Name',
  logTypes = 'Log Type',
  logNames = 'Action',
  userEmails = 'User',

  artifactName = 'Artifact',
  UniqueLibs = 'Unique Libs',
  FilePaths = 'File Paths',
}

export enum FilterTypeToFilter {
  Apps = 'apps',
  Criticality = 'criticality',
  Category = 'categories',
  IssueNames = 'issueNames',
  issueName = 'issueName',
  Policy = 'policies',
  IssueOwner = 'issueOwners',
  AppBusinessPriority = 'businessPriority',
  SourceTool = 'sourceTools',
  BusinessPriority = 'businessPriority',
  CWE = 'cwe',
  RepoType = 'repoTypes',
  Orchestrator = 'orchestrators',
  Artifacts = 'artifacts',
  ArtifactsSystem = 'artifactsSystem',
  Cicd = 'cicd',
  CloudDeployments = 'cloudDeployments',
  Cloud = 'cloud',
  Kubernetes = 'kubernetes',
  Sca = 'sca',
  Sast = 'sast',
  SecretSearch = 'secretSearch',
  Iac = 'iac',
  SecurityToolSource = 'securityToolSource',
  SeverityChange = 'severityChange',
  SeverityChangeReasons = 'severityChangeReasons',
  IssueStatus = 'issueStatus',
  IssueActions = 'issueActions',
  SourceControl = 'sourceControl',
  CloudTechnology = 'cloudTechnology',
  Enviorment = 'enviorment',
  User = 'user',
  Version = 'version',
  ExecutionStatus = 'executionStatus',
  ArtifactTypes = 'artifactType',
  JobTriggeredBy = 'jobTriggeredBy',
  Enforcement = 'enforcement',
  CicdIssueStatus = 'cicdIssueStatus',
  JobNumber = 'jobNumber',
  PullRequests = 'pullRequests',
  IssueCategories = 'issueCategories',
  IssueSeverities = 'issueSeverities',
  RegistryType = 'registryType',
  LibraryNames = 'libraryNames',
  LibraryVersions = 'libraryVersions',
  Source = 'source',
  SourceType = 'sourceType',

  DependencyTypes = 'dependencyTypes',
  Licenses = 'licenses',
  PackageNames = 'packageNames',
  OxInPipeline = 'oxInPipeline',

  Result = 'result',
  SourceBranches = 'sourceBranches',
  TargetBranches = 'targetBranches',
  Severity = 'severities',
  EventType = 'eventTypes',
  OriginalSeverity = 'originalSeverity',
  Languages = 'languages',
  pkgManagers = 'pkgManagers',
  appName = 'appName',
  exclusionType = 'exclusionType',
  modifiedBy = 'modifiedBy',
  policyName = 'policyName',

  logTypes = 'logTypes',
  logNames = 'logNames',
  userEmails = 'userEmails',

  ArtifactName = 'artifactName',
  FilePaths = 'filePaths',
  UniqueLibs = 'uniqueLibs',
}

export interface FilterDetails {
  name: string;
  count: number;
  id: string;
  percent: number;
  color?: string;
  categoryIcon?: IconType;
  issueOwner?: IssueOwner[];
  splitLabel: string;
  changeNumber: number;
}

export enum FilterCriticality {
  Appoxalypse = 'Appoxalypse',
  Critical = 'Critical',
  High = 'High',
  Medium = 'Medium',
  Low = 'Low',
  Info = 'Info',
}

export interface IssueOwner {
  name: string;
  email: string;
}

export enum FilterTypeSearch {
  apps = 'apps',
  issueNames = 'issueNames',
  policies = 'policies',
  issueOwners = 'issueOwners',
  issueOwner = 'issueOwner',

  cwe = 'cwe',
  severityChangeReasons = 'severityChangeReasons',

  jobTriggeredBy = 'jobTriggeredBy',
  pullRequests = 'pullRequests',
  jobNumber = 'jobNumber',

  libraryNames = 'libraryNames',
  libraryVersions = 'libraryVersions',
  packageNames = 'packageNames',

  sourceBranches = 'sourceBranches',
  targetBranches = 'targetBranches',
  languages = 'languages',
  appName = 'appName',
  issueName = 'issueNames',

  artifactName = 'artifactName',
  version = 'version',
  user = 'user',

  logTypes = 'logTypes',
  logNames = 'logNames',
  userEmails = 'userEmails',
  FilePaths = 'filePaths',
  UniqueLibs = 'uniqueLibs',
}

export enum filterNoneTypes {
  None = 'None',
}

export interface FilterElements {
  id?: string;
  label: string;
  filterId: string;
  count: number;
  percent: number;
  changeNumber: number;
}

export enum FilterCriticalityToSeverity {
  Appoxalypse = 'appox',
  Critical = 'critical',
  High = 'high',
  Medium = 'medium',
  Low = 'low',
  Info = 'info',
}

export const createFilters = (
  filtersType: FilterElements[],
): FilterDetails[] => {
  return (
    filtersType &&
    filtersType.map(filter => ({
      name: filter.label,
      count: filter.count,
      percent: filter.percent,
      id: filter.filterId,
      changeNumber: filter.changeNumber,
      categoryIcon: generateCategoryIcon(filter.label as CategoryDisplayName),
      color:
        getCurrentTheme().palette.categoryRiskColor[
          FilterCriticalityToSeverity[filter.label as FilterCriticality]
        ],
      splitLabel: splitLongNames(filter.label, 24),
    }))
  );
};

export const filterNoneOnlyFilters = (
  filtersList: FilterElements[],
  totalApplications: number,
) => {
  const checkFiltersList =
    (filtersList &&
      filtersList.length > 0 &&
      filtersList?.[0]?.label === filterNoneTypes.None &&
      filtersList?.[0]?.count === totalApplications &&
      filtersList.length === 1) ||
    (filtersList && filtersList.length > 0 && filtersList?.[0]?.label === null);
  if (checkFiltersList) {
    return false;
  }
  return true;
};

export const atlasSearch = (filterType: string) => {
  if (
    filterType === FilterTypeSearch.apps ||
    filterType === FilterTypeSearch.issueNames ||
    filterType === FilterTypeSearch.issueOwners
  ) {
    return true;
  }
  if (
    filterType === FilterTypeSearch.FilePaths ||
    filterType === FilterTypeSearch.UniqueLibs
  ) {
    return true;
  }
  return false;
};

export const usingAtlasSearch = (
  issuesFiltersType: Nullable<FilterIssueType>,
  totalIssues: number,
  filter: Filter,
  searchValues: SearchInput[],
  issuesFiltersTypeSearch: Nullable<FilterIssueType>,
) => {
  if (issuesFiltersType && issuesFiltersTypeSearch && totalIssues > 0) {
    if (
      issuesFiltersType[filter.type]?.length > 0 ||
      (searchValues.length > 0 &&
        searchValues.find(filterName => filterName.fieldName === filter.type))
    ) {
      return true;
    }
  }
  return false;
};
